module.exports = __webpack_public_path__ + "img/wechat.94e09ec7.svg";